<mat-card class="balance-transactions-card default m-0" data-balance-transactions-card>
  <mat-progress-bar [mode]="loading() ? 'indeterminate' : 'determinate'" data-balance-transactions-progress></mat-progress-bar>
  <mat-card-title fxLayoutAlign="start center">
    <span>{{ 'balance.transactions.title' | translate }}</span>
    <span fxFlex></span>
    <button mat-icon-button type="button" (click)="refresh()" data-balance-transactions-refresh>
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card-title>

  <mat-card-content>

    <p *ngIf="error() as errorKey" class="balance-transactions-card__error" data-balance-transactions-error>
      {{ errorKey | translate }}
    </p>

    <p
      *ngIf="!loading() && transactions().length === 0 && !error()"
      class="balance-transactions-card__empty text-center py-5"
      data-balance-transactions-empty
    >
      {{ 'balance.transactions.empty' | translate }}
    </p>

    <table
    *ngIf="transactions().length > 0"
    mat-table
    [dataSource]="transactions()"
    data-balance-transactions-table>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>{{ 'balance.transactions.date' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.createdAt | date:'medium' }}</td>
    </ng-container>
    <ng-container matColumnDef="method">
      <th mat-header-cell *matHeaderCellDef>{{ 'balance.transactions.method' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.methodDisplay | translate }}</td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>{{ 'balance.transactions.type' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.typeDisplay | translate }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>{{ 'balance.transactions.status' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.statusDisplay | translate }}</td>
    </ng-container>
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef>{{ 'balance.transactions.amount' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.amount | currency:'USD' }}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <button
          *ngIf="canRefund(row)"
          mat-button
          color="warn"
          type="button"
          (click)="onRefund(row)"
          data-balance-transactions-refund>
          {{ 'balance.transactions.refund' | translate }}
        </button>
      </td>
    </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card-content>
</mat-card>
